import React, { useState, useEffect } from "react";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faPlus, faClock } from "@fortawesome/free-solid-svg-icons";
import { StyledDataGrid } from "../../../common/components/DataGrid/styles";
import { StyledButton } from "../../../common/components/Button";
import AddServiceProviderDialog from "./AddServiceProviderDialog";
import { StyledH2 } from "../../../common/components/Title/styles";
import UpdateServiceProviderDialog from "./UpdateServiceProviderDialog";
import { getServiceProviders } from "../../../api/serviceProviderApi";

import { useNavigate } from "react-router-dom";
const ServiceProvidersTable = ({ serviceData, theme }) => {
  const navigate = useNavigate();

  const [openAddServiceProvider, setOpenAddServiceProvider] = useState(false);
  const [openUpdateServiceProvider, setOpenUpdateServiceProvider] =
    useState(false);
  const [rows, setRows] = useState([]);
  const [currentServiceProvider, setCurrentServiceProvider] = useState({});

  useEffect(() => {
    fetchServiceProviders();
  }, []);

  const fetchServiceProviders = async () => {
    console.log(serviceData.id);
    const response = await getServiceProviders(serviceData.id);

    setRows([...response]);
  };

  const handleOpenAddServiceProvider = () => {
    setCurrentServiceProvider({ serviceId: serviceData.id });
    setOpenAddServiceProvider(true);
  };

  const handleCloseAddServiceProvider = () => {
    setOpenAddServiceProvider(false);
  };
  //Update
  const handleOpenUpdateServiceProvider = (event, params) => {
    event.stopPropagation();
    setCurrentServiceProvider({ ...params.row, serviceId: serviceData.id });
    setOpenUpdateServiceProvider(true);
  };
  const handleCloseUpdateServiceProvider = () => {
    setOpenUpdateServiceProvider(false);
  };

  const columns = [
    { field: "name", headerName: "Service Provider Name", flex: 1 },
    { field: "description", headerName: "Description", flex: 1 },
    { field: "email", headerName: "Email", flex: 1 },
    { field: "price", headerName: "Price", flex: 1 },
    { field: "imageUrl", headerName: "Image Url", flex: 1 },
    { field: "sequence", headerName: "Sequence", flex: 1 },
    {
      field: "col5",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            <GridActionsCellItem
              icon={<FontAwesomeIcon icon={faPen} />}
              label="Update"
              onClick={(e) => handleOpenUpdateServiceProvider(e, params)}
            />
            {serviceData.type === "Online Consultation" ? (
              <GridActionsCellItem
                icon={<FontAwesomeIcon icon={faClock} />}
                label="Scheduler"
                onClick={(e) => {
                  navigate("schedule", { state: params.row });
                }}
              />
            ) : null}
          </>
        );
      },
    },
  ];

  return (
    <div>
      <StyledH2 theme="purple">Service Providers</StyledH2>
      <StyledButton onClick={handleOpenAddServiceProvider} theme="green">
        <FontAwesomeIcon icon={faPlus} style={{ paddingRight: "3px" }} />
        Add service provider
      </StyledButton>
      <UpdateServiceProviderDialog
        openUpdateServiceProvider={openUpdateServiceProvider}
        handleCloseUpdateServiceProvider={handleCloseUpdateServiceProvider}
        currentServiceProvider={currentServiceProvider}
        fetchServiceProviders={fetchServiceProviders}
      />
      <AddServiceProviderDialog
        openAddServiceProvider={openAddServiceProvider}
        handleCloseAddServiceProvider={handleCloseAddServiceProvider}
        currentServiceProvider={currentServiceProvider}
        fetchServiceProviders={fetchServiceProviders}
      />
      <StyledDataGrid autoHeight rows={rows} columns={columns} />
    </div>
  );
};

export default ServiceProvidersTable;
